import TopNav from "@/pages/home/components/TopNav";
import HeroFocus from "@/pages/home/components/HeroFocus";
import FlashNews from "@/pages/home/components/FlashNews";
import HeadlineFeed from "@/pages/home/components/HeadlineFeed";
import HotRanking from "@/pages/home/components/HotRanking";
import DiscussionBoard from "@/pages/home/components/DiscussionBoard";
import GalleryWall from "@/pages/home/components/GalleryWall";
import TrustFaq from "@/pages/home/components/TrustFaq";
import SubscribeBand from "@/pages/home/components/SubscribeBand";
import SiteFooter from "@/pages/home/components/SiteFooter";

export default function Home() {
  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <TopNav />
      <main className="flex-1">
        <HeroFocus />
        <FlashNews />
        <HeadlineFeed />
        <HotRanking />
        <DiscussionBoard />
        <GalleryWall />
        <TrustFaq />
        <SubscribeBand />
      </main>
      <SiteFooter />
    </div>
  );
}